export const ERR_USER_WITHOUT_PRODUCTS = 'Você deve ter ao menos um produto em seu carrinho para fazer o login';
